(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const navs = document.querySelectorAll('[data-cp-desktop-nav]');

  if (!navs.length) {
    return;
  }

  const closeItem = (item) => {
    const trigger = item.querySelector('[data-cp-desktop-nav-trigger]');
    const panel = item.querySelector('[data-cp-desktop-nav-panel]');

    item.classList.remove('is-open');

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }

    if (panel) {
      panel.hidden = true;
    }
  };

  const openItem = (item) => {
    const trigger = item.querySelector('[data-cp-desktop-nav-trigger]');
    const panel = item.querySelector('[data-cp-desktop-nav-panel]');

    if (!trigger || !panel || !desktopQuery.matches) {
      return;
    }

    const nav = item.closest('[data-cp-desktop-nav]');
    nav.querySelectorAll('[data-cp-desktop-nav-item].is-open').forEach((openNavItem) => {
      if (openNavItem !== item) {
        closeItem(openNavItem);
      }
    });

    item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
  };

  navs.forEach((nav) => {
    const items = nav.querySelectorAll('[data-cp-desktop-nav-item]');

    items.forEach((item) => {
      const trigger = item.querySelector('[data-cp-desktop-nav-trigger]');

      if (!trigger) {
        return;
      }

      item.addEventListener('mouseenter', () => openItem(item));

      trigger.addEventListener('focus', () => openItem(item));

      trigger.addEventListener('click', (event) => {
        if (!desktopQuery.matches || item.classList.contains('is-open')) {
          return;
        }

        event.preventDefault();
        openItem(item);
      });
    });

    nav.addEventListener('mouseleave', () => {
      nav.querySelectorAll('[data-cp-desktop-nav-item].is-open').forEach(closeItem);
    });

    nav.addEventListener('focusout', (event) => {
      if (!nav.contains(event.relatedTarget)) {
        nav.querySelectorAll('[data-cp-desktop-nav-item].is-open').forEach(closeItem);
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    document.querySelectorAll('[data-cp-desktop-nav-item].is-open').forEach(closeItem);
  });

  const closeOnBreakpointChange = () => {
    document.querySelectorAll('[data-cp-desktop-nav-item].is-open').forEach(closeItem);
  };

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', closeOnBreakpointChange);
  } else {
    desktopQuery.addListener(closeOnBreakpointChange);
  }
})();
